package feature.address.repository


import feature.address.model.Address
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class AddressRepository {

    val liveData: MutableStateFlow<ArrayList<Address>> = MutableStateFlow(arrayListOf())

    val allLiveData: StateFlow<ArrayList<Address>>
        get() = liveData

    val selectedAddressState: MutableStateFlow<Address> = MutableStateFlow(Address())
    val selectedAddress: StateFlow<Address>
        get() = selectedAddressState

    val newAddressState: MutableStateFlow<Address> = MutableStateFlow(Address())
    val newAddress: StateFlow<Address>
        get() = newAddressState

    val editAddressState: MutableStateFlow<Address> = MutableStateFlow(Address())
    val editAddress: StateFlow<Address>
        get() = editAddressState

}
